import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-grid-system';
import MatchTime from '../shared/MatchTime';
import TeamLabel from '../shared/TeamLabel';
import Result from '../TimeResults/Result';
import { MatchRowWrapper } from './styles';
import ConfigManager from '../../common/configManager/configManager';
import Label from '../shared/Label';
import { prettyMatchUrl } from '../../common/rcs_gaz_mc_core_FE';
//import * as status from '../../constants';


const MatchRowDashed = ({
  matchRow, isMobile, isHighlight, isGazzanetWidget,
}) => {
  const isHomeWinner = () => (Number(matchRow.getIn(['homeTeam', 'score'])) > Number(matchRow.getIn(['awayTeam', 'score'])))
    && matchRow.get('status') !== 'LIVE';
  const isAwayWinner = () => (Number(matchRow.getIn(['homeTeam', 'score'])) < Number(matchRow.getIn(['awayTeam', 'score'])))
    && matchRow.get('status') !== 'LIVE';
  //const isLive = () => matchRow.get('status') === 'LIVE';
  const imagesURL = ConfigManager.getFootballTeams('min');

  const awayResPen = (matchRow.getIn(['awayTeam', 'starData', 'shootOuts', 'score'])) ?
    matchRow.getIn(['awayTeam', 'starData', 'shootOuts', 'score']) : 0;
  const homeResPen = (matchRow.getIn(['homeTeam', 'starData', 'shootOuts', 'score'])) ?
    matchRow.getIn(['homeTeam', 'starData', 'shootOuts', 'score']) : 0;

  const getGazzanetDomain = (url) => {
    let returnedDomain = 'gazzetta';
    if (url && url.hostname) {
      const site = url.hostname;
      const [, domain] = site.split('.');
      returnedDomain = domain;
    }
    return returnedDomain;
  };

  /* Const isGazzanet = () => {
    let disableLink = true;
    if (process.env.REACT_APP_SITE === 'gazzanet') {
      if (window.location && window.location.hostname) {
        const site = window.location.hostname;
        switch (site) {
          case 'www.fcinter1908.it':
          case 'www.forzaroma.info':
          case 'www.calcionapoli1926.it':
          case 'dev.fcinter1908.it':
          case 'dev.forzaroma.info':
          case 'dev.calcionapoli1926.it':
            disableLink = false;
            break;
          default:
            disableLink = true;
            break;
        }
      } else {
        disableLink = true;
      }
    } else {
      disableLink = false;
    }
    return disableLink;
  }; */

  return (
    <MatchRowWrapper
      isHighlight={isHighlight}
      className="has-border-primary"
      href={isGazzanetWidget ? '' : prettyMatchUrl(matchRow.getIn(['homeTeam', 'teamName']), matchRow.getIn(['awayTeam', 'teamName']), matchRow.get('matchId'), 1, matchRow.get('competitionId'), getGazzanetDomain(window.location))}
      disableLink={isGazzanetWidget ? 'disableLink' : ''}
    >
      <Row style={{
        width: '100%', marginRight: '0', marginLeft: isGazzanetWidget ? '5px' : 0, alignItems: 'center',
      }}
      >
        <Col md={5} sm={5} xs={5} style={{ paddingLeft: 0, paddingRight: 0 }}>
          <TeamLabel
            label={matchRow.getIn(['homeTeam', 'teamName'])}
            color="black"
            image={`${imagesURL}${matchRow.getIn(['homeTeam', 'teamId'])}.png`}
            marginLeft={0.5}
            font={isHomeWinner() ? 'narrowMedium' : 'narrowRegular'}
            size={isGazzanetWidget ? 13 : 14}
            isStripCalendar
          />
        </Col>
        <Col md={2} sm={2} xs={2} style={{ paddingRight: 0, paddingLeft: 0 }}>
          {(matchRow.get('status') === 'PREMATCH' && matchRow.get('status') !== 'POSTPONED') &&
            <MatchTime
              date={matchRow.get('date')}
            />
          }
          {(matchRow.get('status') !== 'PREMATCH' && matchRow.get('status') !== 'POSTPONED') &&
            <Result
              awayRes={matchRow.getIn(['awayTeam', 'score'])}
              homeRes={matchRow.getIn(['homeTeam', 'score'])}
              awayPenRes={awayResPen}
              homePenRes={homeResPen}
              status={matchRow.get('status')}
              isMobile={isMobile}
              isFav
            />
          }
          {matchRow.get('status') === 'POSTPONED' &&
            <Label
              label="Rinviata"
              size={0.8}
              textAlignment="center"
              block
            />
          }
        </Col>
        <Col md={5} sm={5} xs={5} style={{ paddingLeft: 0, paddingRight: 0 }}>
          <TeamLabel
            label={matchRow.getIn(['awayTeam', 'teamName'])}
            color="black"
            image={`${imagesURL}${matchRow.getIn(['awayTeam', 'teamId'])}.png`}
            marginLeft={0.5}
            font={isAwayWinner() ? 'narrowMedium' : 'narrowRegular'}
            size={isGazzanetWidget ? 13 : 14}
            isStripCalendar
          />
        </Col>
      </Row>
    </MatchRowWrapper>
  );
};

MatchRowDashed.propTypes = {
  matchRow: PropTypes.any,
  isMobile: PropTypes.bool,
  isHighlight: PropTypes.bool,
  isGazzanetWidget: PropTypes.bool,
};

export default MatchRowDashed;



// WEBPACK FOOTER //
// ./src/components/MatchRowDashed/index.js